import React from 'react';
import { FilterClassificationContext } from '../../contexts/classification';

export const useFilterClassification = () => React.useContext(FilterClassificationContext);